import { render, staticRenderFns } from "./EventsControls.vue?vue&type=template&id=c4e4966e&scoped=true&"
import script from "./EventsControls.vue?vue&type=script&lang=js&"
export * from "./EventsControls.vue?vue&type=script&lang=js&"
import style0 from "./EventsControls.vue?vue&type=style&index=0&id=c4e4966e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e4966e",
  null
  
)

export default component.exports